<template>
  <s-menu-item :key="item.name" :name="item.name" :index="item.index">
    <router-link class="ellipsis-item menu-quota" :to="{ name: item.name }">
      <span class="ellipsis-text">{{ $i18n(item.meta.title) }}</span>
    </router-link>
    <span v-if="showQuotaModeSwitch" @click.stop="handleClickSwitch">
      <svg-icon
        style="width: 16px; height: 16px"
        icon-class="cycle-count-switcher"
        class="cycle-count-switcher-icon"
      />
    </span>
  </s-menu-item>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';
import Store from '@/store';
import { ElLoadingComponent } from 'element-ui/types/loading';
import { switchAsnQuotaMode } from '@/api/wms-config/quota-config';
import { getCookie } from '@/utils/cookie';

const QUOTA_MODE_SWITCH_PERMISSION =
  'PC.RuleCenter.QuotaConfig.ASNQuotaConfiguration.Switch';

@Component
export default class AsnQuotaConfigMenuItem extends Vue {
  // @Prop() readonly openLink: Function;
  @Prop() readonly item: Record<string, any>;

  loadingRef: null | ElLoadingComponent = null;
  isSwitching = false;

  get showQuotaModeSwitch() {
    return Boolean(
      this.$hasPermission(QUOTA_MODE_SWITCH_PERMISSION) &&
        Store.state.system.asnQuotaAllowSwitch
    );
  }

  async handleClickSwitch() {
    if (this.isSwitching) return;

    const warehouseId = getCookie('setting_whs_v2') || '';
    if (!warehouseId || !this.$hasPermission(QUOTA_MODE_SWITCH_PERMISSION))
      return;

    this.isSwitching = true;
    try {
      await Store.dispatch('loadDisplaySettings');
      if (
        warehouseId !== (getCookie('setting_whs_v2') || '') ||
        !this.$hasPermission(QUOTA_MODE_SWITCH_PERMISSION) ||
        !Store.state.system.asnQuotaAllowSwitch
      ) {
        return;
      }

      const curQuotaMode =
        Number(Store.state.warehouseDetail?.warehouse?.quota_mode) === 1
          ? 1
          : 0;
      if (!curQuotaMode) {
        await this.$confirm(
          this.$i18n('Confirm to switch into Separated Quota?'),
          this.$i18n('Notice')
        );
      } else {
        await this.$confirm(
          this.$i18n('Confirm to switch into Integrated Quota?'),
          this.$i18n('Notice')
        );
      }

      if (
        warehouseId !== (getCookie('setting_whs_v2') || '') ||
        !this.$hasPermission(QUOTA_MODE_SWITCH_PERMISSION) ||
        !Store.state.system.asnQuotaAllowSwitch ||
        (Number(Store.state.warehouseDetail?.warehouse?.quota_mode) === 1
          ? 1
          : 0) !== curQuotaMode
      ) {
        return;
      }

      this.loadingRef = this.$loading({
        fullscreen: true,
        text: this.$i18n('Loading'),
      });
      try {
        await switchAsnQuotaMode({
          current_mode: curQuotaMode,
          new_mode: +!curQuotaMode,
        });
      } catch (error) {
        const fallbackMessage = this.$i18n(
          'Switch failed, please try again later!'
        );
        const errorMessage = (error as any)?.message;
        await this.$message.error(
          errorMessage ? this.$i18n(errorMessage, [], true) : fallbackMessage
        );
        return;
      }

      await Store.dispatch('loadWarehouseDetail');
      await this.$message.success(this.$i18n('Switch successfully!'));
      if (this.$route.name === 'ruleCenter.quotaConfig.asnQuotaConfig.edit') {
        this.$router.push({ name: 'ruleCenter.quotaConfig.asnQuotaConfig' });
      }
    } catch {
      // The request wrapper reports refresh errors, and canceling the confirmation is expected.
    } finally {
      this.loadingRef && (this.loadingRef as ElLoadingComponent).close();
      this.isSwitching = false;
    }
  }
}
</script>

<style scoped lang="scss">
.ellipsis-item {
  display: flex;

  .ellipsis-text {
    overflow: hidden;
    width: 150px;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

::v-deep .menu-quota {
  color: rgba(255, 255, 255, 0.6);

  &:hover {
    color: rgb(255, 255, 255);
  }

  &::before {
    position: absolute;
    top: 0;
    right: 25px;
    width: 100%;
    height: 100%;
    content: '';
  }
}
// ::v-deep {
//   .ssc-menu-item-selected .menu-item {
//     font-weight: 700;
//     color: rgb(255, 255, 255);
//   }
// }
.cycle-count-switcher-icon {
  vertical-align: middle;
  // margin-left: 10px;
}
</style>
